import { render, staticRenderFns } from "./EnrollmentExpiredToken.vue?vue&type=template&id=a95d9142&scoped=true"
import script from "./EnrollmentExpiredToken.vue?vue&type=script&lang=js"
export * from "./EnrollmentExpiredToken.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentExpiredToken.vue?vue&type=style&index=0&id=a95d9142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95d9142",
  null
  
)

export default component.exports